import { ChangeRequestResultPage } from "@repo/ui";
import { type FC } from "react";

export interface IChangeRequestError {
	heading?: string;
	description?: string;
}

const ChangeRequestError: FC<IChangeRequestError> = ({ heading, description }) => {
	return (
		<ChangeRequestResultPage
			status="failed"
			titleOverride={heading}
			bodyText={description}
			bodyVariant="plain"
		/>
	);
};

export default ChangeRequestError;
